import React, { Component } from 'react';
import { MdClose } from 'react-icons/md';
import { MdWarning } from 'react-icons/md';
import { MdError } from 'react-icons/md';
import { MdCheckCircle } from 'react-icons/md';
import createStyledComponent from '../utils/createStyledComponent.js';
import styles from './styles/index.js';
const NotificationWrapper = createStyledComponent(styles);
class Notification extends Component {
    constructor() {
        super(...arguments);
        this.getIcon = () => {
            switch (this.props.type) {
                case 'warning':
                    return React.createElement(MdWarning, null);
                case 'error':
                    return React.createElement(MdError, null);
                case 'success':
                    return React.createElement(MdCheckCircle, null);
                default:
                    return null;
            }
        };
    }
    shouldComponentUpdate(nextProps) {
        return (nextProps.children !== this.props.children ||
            nextProps.type !== this.props.type);
    }
    render() {
        return (React.createElement(NotificationWrapper, { type: this.props.type, theme: this.props.theme },
            this.getIcon(),
            React.createElement("span", null, this.props.children),
            this.props.onClose && (React.createElement("button", { onClick: this.props.onClose },
                React.createElement(MdClose, null)))));
    }
}
Notification.defaultProps = {
    type: 'info',
};
export default Notification;
